<template>
  <div class="type-list">
    <van-tabs v-if="typeListTab" @click="changeTab" v-model="actitve" :class="typeListTab.length ==1 ? 'no-tab':''">
      <van-tab v-for="(item,index) in typeListTab" :key="index" :title="item.name">
        <!-- <div v-if="typeListTab.length == 1" class="title">{{item.name}}</div> -->
      </van-tab>

    </van-tabs>
    <van-pull-refresh ref="REFIDList" id="IDList" class="listContainer" v-model="isLoading" @refresh="onRefresh" success-text="刷新成功">
      <van-list v-model="loading" :immediate-check="false" :finished="finished" finished-text="没有更多了" @load="onLoad" :offset="1">
        <div class="item-box" v-if="typeList">
          <van-row class="list">
            <itemInfo @navDetail="navToDetail" v-for="(itemInfo,index) in typeList" :key="index" :itemInfo="itemInfo"></itemInfo>

          </van-row>
        </div>
      </van-list>
    </van-pull-refresh>
    <div class="page-name">{{parentName}}</div>
    <div class="goback-page" @click="typeListEvent">
      <van-icon name="arrow-left" />
    </div>
  </div>
</template>

<script>
import { getTypeList, getGory } from "@/api/index";
import itemInfo from "@/components/itemInfo";
import { Toast } from "vant";

export default {
  name: "typeList",
  components: {
    itemInfo,
  },
  data() {
    return {
      actitve: 0,
      typeList: [],
      typeListTab: null,
      isLoading: true,
      loading: false,
      finished: false,
      parentName: "",
      data: {
        categoryId: "",
        page: 0,
        size: 10,
      },
      isCanGet: false,
    };
  },
  destroyed() {
    //移除当前页面的监听，App不能重复添加监听
    this.data = {
      categoryId: "",
      page: 0,
      size: 10,
    };
  },
  mounted() {
    console.log(this.$store.state.base.typelist);
    this.data = this.$store.state.base.typelist;
    console.log(this.data);
    this.getUiGory(this.$route.query.id);
  },

  methods: {
    typeListEvent() {
      //   this.$route.meta.keepAlive = false;
      this.$router.go(-1);
    },
    navToDetail(id) {
      //   this.$route.meta.keepAlive = true;

      this.$router.push({
        path: "/type/detail",
        name: "商品详情",
        query: {
          id: id,
        },
      });
    },
    onRefresh() {
      Toast("刷新成功");
      this.isLoading = false;
      this.typeList = [];
      this.data = {
        categoryId: this.data.categoryId,
        page: 0,
        size: 10,
      };
      this.finished = false;
      // this.onLoad();
    },
    onLoad() {
      // 异步更新数据
      const nextPaging = {
        categoryId: this.data.categoryId,
        page: this.data.page + 1,
        size: 10,
      };
      this.data = nextPaging;
      if (this.isCanGet) {
        this.getUiTypeList(this.data);
      }
    },
    getUiTypeList(data) {
      getTypeList(data).then((res) => {
        if (res.data.errno == 0) {
          let newOfRes = JSON.parse(JSON.stringify(res.data.data));
          this.typeList = this.typeList.concat(newOfRes.goodsList);
          this.loading = false;
          // // 数据全部加载完成
          if (this.typeList.length == newOfRes.count) {
            this.finished = true;
          }
        }
      });
    },
    getUiGory(id) {
      getGory(id).then((res) => {
        if (res.data.errno == 0) {
          if (this.$store.state.base.typelist == null) {
            console.log(this.data);
            this.data = {
              categoryId: res.data.data.currentCategory.id,
              page: 0,
              size: 10,
            };
          } else {
            this.data = this.$store.state.base.typelist;
          }
          this.isCanGet = true;
          this.onLoad();
          this.parentName = res.data.data.parentCategory.name;
          this.typeListTab = res.data.data.brotherCategory;
          this.typeListTab.forEach((element, index) => {
            if (element.id == this.data.categoryId) {
              console.log(index);
              this.actitve = index;
            }
          });
        }
        console.log(res);
      });
    },
    changeTab(index) {
      console.log(index);
      this.data = {
        categoryId: this.typeListTab[index].id,
        page: 1,
        size: 10,
      };
      console.log(this.data);
      this.$store.commit("SET_TYPELIST", this.data);
      this.typeList = [];
      this.getUiTypeList(this.data);
    },
  },
};
</script>

<style lang="scss" scoped>
.goback-page {
  background: #fff;
  position: fixed;
  top: 0;
  left: 2rem;
  z-index: 4;
  height: 6rem;
  width: 5rem;
  display: flex;
  align-items: center;
  font-size: 2.3rem;
}
.type-list {
  height: 100%;
  background: #eee;
  /*控制底部滚动*/
  overflow-y: scroll;
  .title {
    margin: 2rem 0;
    font-size: 1.6rem;
  }
}
.item-box {
  width: 100%;
  padding-bottom: 1rem;

  .list {
    width: 100%;
    margin: 0 auto;
  }
}
.no-tab {
  /deep/ .van-tabs__wrap {
    display: none;
  }
}
/deep/ .van-tab--active {
  font-family: PingFangSC-Regular;
  font-size: 1.4rem;
  color: #a9936b;
  letter-spacing: 0;
}
/deep/ .van-tabs__line {
  background-color: #a9936b;
}
/deep/ .van-tabs {
  position: relative;
  // margin-bottom: 1rem;
  border-bottom: 1rem solid #f4f4f4;
}
.page-name {
  font-family: PingFangSC-Regular;
  font-size: 1.8rem;
  color: #000;
  letter-spacing: 0;
  text-align: center;
  height: 59px;
  line-height: 59px;
  background: #fff;
  width: 50%;
  position: fixed;
  top: 0;
  z-index: 1;
  left: 50%;
  margin-left: -25%;
}
</style>



// WEBPACK FOOTER //
// src/view/index/typeDetail.vue